"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _iconButton = _interopRequireDefault(require("../icon-button"));
var _close = _interopRequireDefault(require("../../icons/close"));
require("./close-button.css");
var _excluded = ["alignment", "ariaLabel", "className", "highContrast"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A close button for use in modals, overlays, bottom sheets, and similar. Includes
 * two alignment presets anchoring the button to the top right or top left of a
 * relative container.
 *
 * For more complex layouts, you can ignore the alignment prop to render the component
 * without any positioning build in, allowing you to provide your own.
 */
var CloseButton = function CloseButton(_ref) {
  var alignment = _ref.alignment,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? 'Close' : _ref$ariaLabel,
    className = _ref.className,
    highContrast = _ref.highContrast,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_iconButton["default"], _extends({
    ariaLabel: ariaLabel,
    className: (0, _classnames["default"])('sb-closeButton', _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, className, Boolean(className)), 'position-absolute', Boolean(alignment)), 'sb-closeButton--right', alignment === 'right'), 'sb-closeButton--left', alignment === 'left')),
    highContrast: highContrast,
    path: _close["default"]
  }, otherProps));
};
CloseButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Optional right or left alignment to pull the close button to the top right or top left edge
   * of its container, using absolute positioning.
   */
  alignment: _propTypes["default"].oneOf(['right', 'left']),
  className: _propTypes["default"].string,
  /**
   * `aria-label` applied to button.
   */
  ariaLabel: _propTypes["default"].string,
  /**
   * optional prop to allow button to be seen more easily on dark backgrounds
   */
  highContrast: _propTypes["default"].bool
} : {};
CloseButton.displayName = 'CloseButton';
var _default = exports["default"] = CloseButton;